<template>
  <div class="container-fluid">
    <div class="form-group">
      <label>ID</label>
      <input type="text" class="form-control" v-model="item.attributes.id.value"/>
    </div>
    <div class="form-group">
      <label>Name</label>
      <input @change="updateName" type="text" class="form-control" v-model="item.attributes.name.value"/>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BPMNNodeBase',
  props: ['item'],
  methods: {
    updateName(e) {
      this.$emit('updateName',e.target.value);
    }
  }
}
</script>
